import { Model } from '@vuex-orm/core';

export class Currency extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'currencies';

  static primaryKey = 'code';

  static fields() {
    return {
      code: this.attr(null),
      name: this.attr(null),
    };
  }
}

export default Currency;
